// Copyright (c) 2022 by Move Closer

import { SizeRegistry, ThemeRegistry } from '../../composables'

import { Theme } from './Button.contract'

export enum ButtonVariantMap {
  Full = 'full',
  Outline = 'outline'
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export enum ButtonSizeMap {
  Medium = 'medium',
  Small = 'small',
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const sizeClassRegistry: SizeRegistry<string> = {
  [ButtonSizeMap.Medium]: '',
  [ButtonSizeMap.Small]: '--small'
}

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const themeClassRegistry: ThemeRegistry<Theme> = {
  [Theme.Danger]: '--danger',
  [Theme.Link]: '--link', // TODO: This shouldn't be here.
  [Theme.Outline]: '--outline',
  [Theme.Primary]: '--primary', // TODO: this should be empty and button should have default styles (like for --primary)
  [Theme.Secondary]: '--secondary',
  [Theme.Success]: '--success'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const buttonVariantRegistry: Record<string, string> = {
  [ButtonVariantMap.Full]: '',
  [ButtonVariantMap.Outline]: '--outline'
}
